import React from "react";
import "./whatsappbutton.css"; // Archivo CSS separado para estilos
import whatsappIcon from "../images/WhatsApp.png"; // Reemplaza con la ruta correcta al ícono

const FloatingWhatsApp = () => {
    const phoneNumber = "+593987608235";
    const message = "¡Hola LaOfi! Me interesa conocer más acerca de ustedes y sus espacios de trabajo ";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    return (
        <div className="whatsapp-wrapper">
            <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src={whatsappIcon} alt="WhatsApp" className="whatsapp-icon" />
                <span className="tooltip">¡Chatea con nosotros!</span>
            </a>
        </div>



    );
};

export default FloatingWhatsApp;
